var render = function render(){var _vm=this,_c=_vm._self._c;return _c('van-icon',{attrs:{"name":"arrow"}})
}
var staticRenderFns = []

export { render, staticRenderFns }